module.exports = __webpack_public_path__ + "media/images/11_help-b4ecc407340d98e78084ba71ca95a1e8.jpg";